const options = {
  5: "bg-neutral-400/5",
  10: "bg-neutral-400/10",
  25: "bg-neutral-400/25",
  50: "bg-neutral-400/50",
  75: "bg-neutral-400/75",
  90: "bg-neutral-400/90",
  100: "bg-neutral-400",
};

const from = {
  5: "from-neutral-400/5",
  10: "from-neutral-400/10",
  25: "from-neutral-400/25",
  50: "from-neutral-400/50",
  75: "from-neutral-400/75",
  90: "from-neutral-400/90",
  100: "from-neutral-400",
};

export default function getBackgroundNeutral400(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
